<template>
  <v-dialog
    ref="loadingDialog"
    data-qa="loading_dialog"
    :value="active"
    persistent
    max-width="300"
    content-class="loading_dialog"
  >
    <v-card :color="customColoursLight.primary">
      <v-card-text class="white--text">
        {{ $m.loading_wait }}
        <v-progress-linear indeterminate color="white" class="mb-0" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import appStore from "@/store/modules/appStore";
import { ReactiveDialog } from "@/components/mixins/dialogs";
import { defineComponent } from "vue";
import { customColoursLight } from "@/plugins/vuetify";
/**
 * Unfortunately when this dialog comes and goes quickly the overlay can sometimes get stuck active. Presumably this is
 * an issue with Vuetify 2.0 - worth removing this complexity once it matures a bit and seeing if the issue still exists.
 */
export default defineComponent({
  name: "BmLoader",
  mixins: [ReactiveDialog],
  data() {
    return {
      minimumLoadTimeMs: 300,
      loadingStartTimeMs: 0,
      loadingTimer: 0,
      overlayTimer: 0,
      active: false,
      customColoursLight,
    };
  },
  computed: {
    loading(): any {
      // Prompts change in loading when the page becomes visible to stop loading state freezing on hidden reload
      return appStore.state.loading && !document.hidden;
    },
  },
  watch: {
    loading: {
      // @ts-ignore
      handler: "loadingWatch",
      immediate: true,
    },
  },
  methods: {
    /**
     * @desc Show loafing dialog and ensure the it appears for a minimum amount of time to prevent flashing.
     */
    loadingWatch(val: boolean, oldVal: boolean) {
      clearTimeout(this.overlayTimer);
      clearTimeout(this.loadingTimer);

      if (val) {
        this.active = true;
        this.loadingStartTimeMs = Date.now();
      } else {
        const now = Date.now();
        const timeSinceLoadingStarted = now - this.loadingStartTimeMs;

        if (timeSinceLoadingStarted < this.minimumLoadTimeMs) {
          this.loadingTimer = +setTimeout(() => {
            this.active = false;

            this.removeOverlayAfterDelay();
          }, this.minimumLoadTimeMs - timeSinceLoadingStarted);
        } else {
          this.active = false;
          this.removeOverlayAfterDelay();
        }
      }
    },
    removeOverlayAfterDelay() {
      this.overlayTimer = +setTimeout(() => {
        this.active = false;
        (this.$refs.loadingDialog as any).removeOverlay();
      }, 100);
    },
  },
});
</script>
